import React from 'react';

function ArktemisPage() {
  return (
    <div className="bg-black-900 text-white pt-20 min-h-screen flex flex-col items-center px-4 space-y-16 overflow-visible">
      
      {/* Heading */}
      <div className="text-center max-w-4xl mx-auto" data-aos="fade-down">
        <h1 className="text-4xl md:text-6xl font-extrabold mb-4 bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent leading-snug">Arktemis AgroBiome: From Seed To Success</h1>
        <p className="text-base md:text-lg text-gray-400">© 2025 Arktemis Foundation</p>
      </div>

      {/* Intro */}
      <section className="max-w-5xl text-center space-y-8 p-8 bg-gray-800 rounded-xl shadow-xl border border-gray-700" data-aos="fade-up">
        <h2 className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">Upgrading Agri Trade to Agri Industry</h2>
        <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
          In agribusiness, success means linking every step—from farm to consumer—in a way that’s smooth, sustainable, and profitable.
          <br />
          Arktemis Foundation helps you enhance your agribusiness to be more productive, efficient, and built to last.
        </p>
      </section>

      {/* Challenges */}
      <section className="max-w-6xl w-full p-8 bg-gray-800 rounded-xl shadow-xl border border-gray-700" data-aos="fade-right">
        <h3 className="text-3xl md:text-4xl font-bold mb-8 text-center text-red-400">Tired of These Challenges?</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-300 list-disc list-inside text-lg md:text-xl leading-relaxed">
          <li>Unpredictable yields ruining your plans?</li>
          <li>Supply chain headaches costing you money?</li>
          <li>Market swings catching you off guard?</li>
          <li>Customers demanding better quality?</li>
          <li>Want to go green but not sure how?</li>
        </ul>
      </section>

      {/* Solutions */}
      <section className="max-w-6xl w-full p-8 bg-gray-800 rounded-xl shadow-xl border border-gray-700" data-aos="fade-left">
        <h3 className="text-3xl md:text-4xl font-bold mb-8 text-center text-green-400">We’ve Got You Covered</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-300 list-disc list-inside text-lg md:text-xl leading-relaxed">
          <li>Know Your Farm Better: Turn raw data into clear, actionable intelligence.</li>
          <li>Market Mastery: Sell smarter with our forecasting insights.</li>
          <li>Smooth Supply Chains: Full traceability ensures right produce, right place, right time.</li>
          <li>Sustainable Profitability: Cut waste, lower costs, unlock new revenue.</li>
          <li>Green Gains: Save resources and earn extra with eco-friendly practices.</li>
          <li>Quality That Sells: Keep customers happy with top-notch produce.</li>
          <li>Built to Scale: From single plots to multi-site operations—our tools grow with you.</li>
        </ul>
      </section>

      {/* Why Choose Arktemis */}
      <section className="max-w-5xl text-center space-y-8 p-8 bg-gray-800 rounded-xl shadow-xl border border-gray-700" data-aos="fade-up">
        <h3 className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">Why Choose Arktemis?</h3>
        <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
          You’ve built a thriving agribusiness on hard work and grit—now let our precision solutions give you that extra edge.
          <br />
          We respect what you’ve achieved and bring the technology, insights, and sustainability strategies to multiply your impact without multiplying effort.
        </p>
      </section>

      {/* CTA Button */}
      <section className="text-center pb-12" data-aos="fade-up">
        <a 
          href="/contact" 
          className="relative inline-flex items-center justify-center p-1 overflow-hidden text-xl font-medium text-gray-900 rounded-full group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 transition-all duration-300 ease-in-out transform hover:scale-105 active:scale-95"
        >
          <span className="relative px-10 py-4 transition-all ease-in duration-150 bg-white dark:bg-gray-900 rounded-full group-hover:bg-opacity-0">
            Ready to Grow? Contact Us
          </span>
        </a>
      </section>

    </div>
  );
}

export default ArktemisPage;